const tabs = document.querySelector(`.tabs`);
const tabsLabels = tabs.querySelectorAll(`.tabs__tab`);
const tabsInputs = tabs.querySelectorAll(`.tabs__input`);

const onLabelClick = (evt, labels) => {
  labels.forEach((label) => {
    label.classList.remove(`tabs__tab--active`);
  });
  evt.target.closest(`.tabs__tab`).classList.add(`tabs__tab--active`);
};

tabsLabels.forEach((label) => {
  label.addEventListener(`click`, (evt) => {
    onLabelClick(evt, tabsLabels);
  });
});